import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

import { AsyncSelectOptions } from 'app/types/select-options';

import { locationsState } from './locationsState';
import { DecoratedAssetStatus } from '../types';

export const locationsSlice = createSlice({
  name: 'locations',
  initialState: locationsState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    // ---------------------------------------------------------
    // API REQUEST STATUSES
    // ---------------------------------------------------------
    setInitializeFetchDataRequestPending: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.isInitializingFetchDataRequestPending = action.payload;
    },
    // ---------------------------------------------------------
    // DATA SOURCE
    // ---------------------------------------------------------
    setVehicles: (state, action: PayloadAction<Array<AsyncSelectOptions>>) => {
      state.vehicles = action.payload;
    },
    setSelectedVehicle: (
      state,
      action: PayloadAction<AsyncSelectOptions | null>,
    ) => {
      state.selectedVehicle = action.payload;
    },
    setAssetStatuses: (
      state,
      action: PayloadAction<Array<DecoratedAssetStatus>>,
    ) => {
      state.assetStatuses = action.payload;
    },
  },
});

/* ------- ACTION CREATORS ------- */
export const { actions: locationStatusActions } = locationsSlice;

/* ------- STATE SELECTORS ------- */
export const selectLocations = (state: RootState) =>
  state.locations || locationsState;

// API Request Statuses
export const makeSelectInitializeFetchDataRequestPending = () =>
  createSelector(
    selectLocations,
    locations => locations.isInitializingFetchDataRequestPending,
  );

// Data Sources
export const makeSelectVehicles = () =>
  createSelector(selectLocations, locations => locations.vehicles);

export const makeSelectVehicle = () =>
  createSelector(selectLocations, locations => locations.selectedVehicle);

export const makeSelectAssetStatuses = () =>
  createSelector(selectLocations, locations => locations.assetStatuses);

export default locationsSlice.reducer;
